// @ts-nocheck
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  trackPageView,
  isPendoInitialized
} from '../../services/pendo/pendo.service';

/**
 * PendoPageTracker Component
 *
 * Automatically tracks page views in Pendo when routes change.
 * This component should be placed in the main layout or app shell.
 *
 * @namespace Components.Analytics
 */
const PendoPageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPage = () => {
      const pageData = {
        url: window.location.href,
        path: location.pathname,
        search: location.search,
        hash: location.hash,
        title: document.title
      };

      trackPageView(location.pathname, pageData);
    };

    if (isPendoInitialized()) {
      trackPage();
    } else {
      // Retry up to 10 times (5 seconds total) waiting for Pendo to initialize
      let attempts = 0;
      const maxAttempts = 10;
      const retryInterval = 500; // 500ms between attempts

      const retryTimer = setInterval(() => {
        attempts++;

        if (isPendoInitialized()) {
          clearInterval(retryTimer);
          trackPage();
        } else if (attempts >= maxAttempts) {
          console.warn(
            '[PendoPageTracker] Gave up waiting for Pendo initialization'
          );
          clearInterval(retryTimer);
        }
      }, retryInterval);

      // Cleanup on unmount
      return () => clearInterval(retryTimer);
    }
  }, [location]);

  // This component doesn't render anything
  return null;
};

export default PendoPageTracker;
